import React, { forwardRef, useEffect, useRef, useState } from "react";
import cx from "classnames";

import { PhoneInput as BasePhoneInput } from "@/ui-lib/FormFields/PhoneInput";

import styles from "./PhoneInput.module.scss";

const PhoneInput = forwardRef(
  (
    {
      value,
      label,
      onChange,
      onBlur,
      placeholder,
      className,
      id,
      inputClassName,
      disabled = false,
      defaultCountry = "",
      autoFocus = false,
    },
    ref
  ) => {
    const [buffer, setBuffer] = useState(value);
    const [countryCode, setCountryCode] = useState("");
    const inputRef = useRef();

    useEffect(() => {
      setCountryCode(defaultCountry);
    }, [defaultCountry]);

    useEffect(() => {
      setBuffer(value);
    }, [value]);

    const inputChangeHandler = (value) => {
      const newValue = value;

      if (onChange) onChange(newValue || "");

      setBuffer(newValue);
    };

    const inputBlurHandler = () => {
      if (onBlur) {
        onBlur(buffer);
        setBuffer(buffer);
      }
    };

    return (
      <div className={cx(styles.inputContainer, className)}>
        {label && <label htmlFor={id}>{label}</label>}
        <BasePhoneInput
          type="tel"
          international
          autoFocus={autoFocus}
          ref={ref || inputRef}
          defaultCountry={countryCode}
          placeholder={placeholder}
          inputClassName={inputClassName}
          id={id || ""}
          onCountryChange={setCountryCode}
          onChange={inputChangeHandler}
          onBlur={inputBlurHandler}
          value={buffer}
          disabled={disabled}
        />
      </div>
    );
  }
);

export default PhoneInput;
